import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Label } from "./ui/label"
import { Switch } from "./ui/switch"
import { Bell, Calendar, HelpCircle, LogOut, Settings, Shield, User,List } from "lucide-react"
import authService from "../Services/authService";

const ProfileScreen = () => {
  const navigate = useNavigate()
  const [userInfo, setUserInfo] = useState([])
  const [availability, setAvailability] = useState(true)


  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'profile/' + authService.getCurrentuser().id);
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        //const data = result.data;
        // if (Array.isArray(result.data) && result.data.length > 0) {
        setUserInfo(result.data); // Store the first object
        setAvailability(result.data.availability_status === 1);
        //}
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleLogout = () => {
    // Simulate logout
    authService.clientlogout();  // Clear the session from auth service
    navigate("/login");
  }

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase()
  }

  const handleToggleAvailability = (checked) => {
  const token = authService.getCurrentUsertoken();
  const userId = authService.getCurrentuser().id;

  // Optimistically update UI
  setAvailability(checked);

  fetch(authService.getApiUrl() + 'availabilitystatus/' + userId, {
    method: 'PUT', // or 'POST' depending on your backend
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token}`,
    },
    // body: JSON.stringify({
    //   availability_status: checked ? 1 : 0,
    // }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Failed to update availability');
      }
      return res.json();
    })
    .then((result) => {
      loadProfile();
      //console.log("Availability updated:", result);
    })
    .catch((error) => {
      console.error("Error updating availability:", error.message);
      // Rollback if failed
      setAvailability(!checked);
    });
};

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="relative h-[100px] w-[100px] mr-3">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-xl font-bold text-gray-800 truncate">Profile & Settings</h1>
        </div>
      </div>

      <Card className="mb-6 border-gray-200">
        <CardContent className="pt-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full mr-4 border-2 border-pranaam-red bg-gray-100">
              <User className="h-8 w-8 text-gray-500" /> {/* Increased size */}
            </div>
            <div className="text-left">
              <h2 className="font-bold text-lg text-gray-800">{userInfo.user_name}</h2>
              <p className="text-sm text-gray-500">Phlebotomist</p>
              <p className="text-sm text-gray-500">EMP-ID: {userInfo.employee_id}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="mb-6 border-gray-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg text-gray-800 text-left">Availability</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <Label htmlFor="availability" className="text-base text-gray-800">
              Available for Collections
            </Label>
            <Switch
              id="availability"
              checked={availability}
              onCheckedChange={handleToggleAvailability}
              className="data-[state=checked]:bg-pranaam-red"
            />
          </div>
          <p className="text-sm text-gray-500 mt-2 text-left">
            {availability
              ? "You are currently available for new collection assignments"
              : "You are currently not available for new collection assignments"}
          </p>
        </CardContent>
      </Card>

      <Card className="mb-6 border-gray-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg text-gray-800 text-left">Account Settings</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="divide-y divide-gray-200">
            {/* <Link to="/profile/personal" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <User className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Personal Information</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link> */}

            <Link to="/attendance/history" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <Calendar className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Attendance History</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link>

             <Link to="/appointments" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <List className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Appointments</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link>

            {/* <Link to="/profile/notifications" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <Bell className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Notification Settings</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link>

            <Link to="/profile/password" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <Shield className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Change Password</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link> */}

            {/* <Link to="/profile/app-settings" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <Settings className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">App Settings</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link> */}
          </div>
        </CardContent>
      </Card>

      <Card className="mb-6 border-gray-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-lg text-gray-800 text-left">Support</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="divide-y divide-gray-200">
            <Link to="/support" className="flex items-center justify-between p-4">
              <div className="flex items-center">
                <HelpCircle className="h-5 w-5 text-gray-500 mr-3" />
                <span className="text-gray-800">Help & Support</span>
              </div>
              <span className="text-gray-400">→</span>
            </Link>
          </div>
        </CardContent>
      </Card>

      <Button variant="destructive" className="w-full bg-pranaam-red hover:bg-red-700" onClick={handleLogout}>
        <LogOut className="h-4 w-4 mr-2" />
        Logout
      </Button>
    </AppLayout>
  )
}

export default ProfileScreen
